import PropTypes from 'prop-types';
import clsx from 'clsx';
import { NavLink } from 'react-router-dom';
import { isEmpty, isFunction } from '@/helpers/is';
import classes from './menu.module.css';

const Menu = (props) => {
  const {
    data = [],
    size = 'md',
  } = props;

  const menuClasses = clsx(classes.menu, size !== 'md' && classes[size]);

  if (isEmpty(data)) {
    return null;
  }

  const links = data.map((link) => {
    const {
      title,
      onClick,
      to,
    } = link;

    return (onClick && isFunction(onClick))
      ? <li key={title}><button className={classes.link}>{title}</button></li>
      : <li key={title}><NavLink className={classes.link} to={to}>{title}</NavLink></li>;
  });

  return (
    <div className={menuClasses}>
      <ul>
        {links}
      </ul>
    </div>
  );
};

Menu.propTypes = {
  data: PropTypes.array,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
};

export default Menu;
